import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { LoginRequestData, LoginEndconsumerResponseData } from "../../models/user.model";
import { AuthService } from "../../services/auth.service";
import { NgxSmartModalService } from "ngx-smart-modal";

@Component({
  selector: 'app-login-team',
  templateUrl: './login-team.component.html',
  styleUrl: './login-team.component.scss'
})
export class LoginTeamComponent implements OnInit {
  private _fb: FormBuilder = inject(FormBuilder);
  private _userService: UserService = inject(UserService);
  private _authService: AuthService = inject(AuthService);

  @Input() henterPantMode!: boolean;
  @Output() getSubscriptionEmit: EventEmitter<void> = new EventEmitter<void>;

  form!: FormGroup;
  loading!: boolean;
  error!: boolean;
  showPassword: boolean = false;
  showForgotPass: boolean = false;

  constructor() {
    this.formInitialize();
  }

  ngOnInit(): void {
  }

  formInitialize(): void {
    this.form = this._fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  onSubmit(): void {
    if (this.loading) return;

    this.error = false;
    this.loading = true;

    if (!this.form.valid) return;
    const formValue = this.form.value;

    const loginData: LoginRequestData = {
      email: formValue.email,
      password: formValue.password
    }

    this._userService.login(loginData).subscribe((result: LoginEndconsumerResponseData) => {
      if (result.user.user_type !== 'team') {
        this.error = true;
        this.loading = false;
        return;
      }
      const accessToken: string = result.tokens.access;
      this._authService.setAccessToken(accessToken);

      this._userService.set(result);
      this.getSubscriptionEmit.emit();
      this.loading = false;
      // TODO add some delay or add extra page for result of login
    }, error => {
      this.error = true;
      this.loading = false;
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  toggleForgotPassword(): void {
    this.showForgotPass = !this.showForgotPass;
  }
}
